import { render, staticRenderFns } from "./WalletNavHeaderMenu.vue?vue&type=template&id=440976cb&scoped=true"
import script from "./WalletNavHeaderMenu.vue?vue&type=script&lang=ts"
export * from "./WalletNavHeaderMenu.vue?vue&type=script&lang=ts"
import style0 from "./WalletNavHeaderMenu.vue?vue&type=style&index=0&id=440976cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440976cb",
  null
  
)

export default component.exports